export const EntityState = {
  All: 'All',
  Closed: 'Closed',
  Open: 'Open',
}
